import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import classroomImage from '../as.avif'; // Substitua pelo caminho da sua imagem

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Login submitted:', { username, password, rememberMe });
  };

  return (
    <div className="page-container">
      <div className="image-section">
        <img src={classroomImage} alt="Classroom" />
        <div className="image-text">Bem Vindo a eBB</div>
      </div>
      <div className="form-section">
        <h1>Vamos aprender Juntos!</h1>
        <div className="tabs">
          <button className="tab active" onClick={() => navigate('/login')}>
            Iniciar Sessao 
          </button>
          <button className="tab" onClick={() => navigate('/Registro')}>
            REGISTAR
          </button>
        </div>
        <p className="description">
          Com a eBB aprendes em qualquer lugar com as melhores Tecnologias 
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome do Usuario</label>
            <input
              type="text"
              placeholder="Enter your User name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Palavra-Passe</label>
            <input
              type="password"
              placeholder="Enter your Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="options">
            <label>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
              />
              Lembre de mim
            </label>
            <a href="#">Esqueceu a palavra-passe?</a>
          </div>
          <button type="submit" className="login-btn">Entrar</button>
        </form>
      </div>
    </div>
  );
};

export default Login;